import axios from "axios"
import { fetchUserDetails, getToken } from "../../helpers";
import { publishAppLoading, publishErrorUpdate } from "../Events/utils.events";
import logger from "../../logger";
import jwtDecode from "jwt-decode";
let xApikey = window?.xApiKey
let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
let apiBaseCachedUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseCachedUrl;
let site = window.app_data.site.siteInternalName
const getSubscriptionPlans = async (skipHba=false) => {
    try {
        let { userId, hba, mvpdProvider } = await fetchUserDetails()
        let locationCoordsData  = sessionStorage.getItem("locationCoords")
        let locationCoords  = JSON.parse(locationCoordsData)
        let latitudeCoords =  !!hba ? hba?.latitude : locationCoords?.latitude 
        let longitudeCoords = !!hba ? hba?.longitude : locationCoords?.longitude
        let token = await getToken(token => { return token })
        if (!userId) {
          let params = {
            site : site,
            device : "web_browser",
            monetizationModel : "SVOD",
            platform : "web_browser",
            latitude: latitudeCoords,
            longitude: longitudeCoords
          }
          let plansApiUrl = `${apiBaseUrl}/v3/plans`
          if(site === 'caliente') {
            let countryCode = jwtDecode(token)?.countryCode;
            params["store_countryCode"] = countryCode
            plansApiUrl = `${apiBaseCachedUrl}/v3/plans`
          }
          if(mvpdProvider) params.mvpdProvider = mvpdProvider
            let res = await axios.get(plansApiUrl,
                {
                    params,
                    headers: {
                        ['x-api-key']: xApikey,
                        authorization: token
                    }
                })
            return res.data
        }
          else {
            let params = {
              site : site,
              userId : userId,
              device : "web_browser",
              monetizationModel : "SVOD",
              platform : "web_browser"
            }
            if(mvpdProvider) params.mvpdProvider = mvpdProvider
            if (hba?.enabled && !skipHba) {
              let locationCoords = JSON.parse(localStorage.getItem("locationCoords"))
              let countryCode = locationCoords?.countryisocode
              let latitude = locationCoords?.latitude
              let longitude = locationCoords?.longitude
              params.countryCode = countryCode
              params.latitude = latitude
              params.longitude = longitude
            }else{
              params.latitude = latitudeCoords
              params.longitude = longitudeCoords
            }
            let res = await axios.get(`${apiBaseUrl}/v3/plans`,
            {
              params: params,
              headers: {
                ['x-api-key']: xApikey,
                authorization : token
              }
            })
            return res.data
          }
    }
    catch (e) {
        logger(`Error Fetching Plans: ${e}`, "error")
        publishErrorUpdate("Error Fetching Plans")
        publishAppLoading(false)
        return null
    }
}
export {getSubscriptionPlans}